import styled from '@emotion/styled';
import { Select, TableRow } from '@material-ui/core';

export const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: #f0f0f7;
    cursor: pointer;
  }
`;

export const StyledSelect = styled(Select)`
  border: 1px solid;
  border-radius: 4px;
  font-size: 1rem;
  outline: none;
  padding: 0.1rem;
  padding-left: 10px;
  width: 100%;
  &:hover,
  &:focus {
    border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
  }
`;

export const RecipesContainer = styled.div`
  float: left;
  min-width: 200px;
`;
